module.exports = __webpack_public_path__ + "static/SetStripeAPI-7759417a2fb9d2bfee855a026c5e3ad5.png";